module.exports = __webpack_public_path__ + "assets/icon-enroll-lottery-en-10c14dd9.png";